import React, { useState, useEffect, useRef } from "react";
import "../../styles/Ferry_RazorpayOTP.css";
import LockIcon from "@mui/icons-material/Lock";
import SecurityIcon from "@mui/icons-material/Security";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";

const Ferry_RazorpayOTP = ({
  isOpen,
  onClose,
  onVerify,
  phoneNumber = "+91 9876543210",
  bookingData = {}, // Add this prop to receive booking data
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      setOtp(["", "", "", "", "", ""]);
      setTimer(30);
      setCanResend(false);
      setIsVerifying(false);
      // Focus first input when modal opens
      if (inputRefs.current[0]) {
        setTimeout(() => inputRefs.current[0].focus(), 100);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (timer > 0 && !canResend) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer, canResend]);

  const handleOtpChange = (index, value) => {
    // Only allow numbers
    if (value && !/^\d$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    // Handle paste
    if (e.key === "v" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      navigator.clipboard.readText().then((text) => {
        const digits = text.replace(/\D/g, "").slice(0, 6).split("");
        const newOtp = [...otp];
        digits.forEach((digit, i) => {
          if (index + i < 6) {
            newOtp[index + i] = digit;
          }
        });
        setOtp(newOtp);
        const nextIndex = Math.min(index + digits.length, 5);
        inputRefs.current[nextIndex]?.focus();
      });
    }
  };

  const handleResendOtp = () => {
    setOtp(["", "", "", "", "", ""]);
    setTimer(30);
    setCanResend(false);
    // Focus first input
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
    // Dummy: In real app, call API to resend OTP
    alert("OTP resent to " + phoneNumber);
  };

const handleVerify = () => {
  const otpString = otp.join("");

  if (otpString.length !== 6) {
    alert("Please enter complete 6-digit OTP");
    return;
  }

  setIsVerifying(true);

  setTimeout(() => {
    setIsVerifying(false);

    console.log('Passing booking data:', bookingData);

    // Navigate to PDF page with ALL the booking data
    navigate("/Ferry_Pdf", {
      state: {
        ...bookingData,
        serviceName: "Ferry_Booking"
      }
    });

    if (onVerify) {
      onVerify(otpString);
    } else {
      onClose();
    }
  }, 1500);
};

  if (!isOpen) return null;

  return (
    <div className="razorpay-otp-overlay" onClick={onClose}>
      <div className="razorpay-otp-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="razorpay-otp-header">
          <div className="razorpay-logo-section">
            <div className="razorpay-logo">
              <LockIcon className="lock-icon" />
            </div>
            <div className="razorpay-brand">
              <h2>Razorpay</h2>
              <p>Secure Payment Gateway</p>
            </div>
          </div>
          <button className="razorpay-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="razorpay-otp-content">
          <div className="otp-title-section">
            <SecurityIcon className="security-icon" />
            <h3>Enter OTP</h3>
            <p className="otp-subtitle">
              We've sent a 6-digit OTP to <strong>{phoneNumber}</strong>
            </p>
          </div>

          {/* OTP Input Fields */}
          <div className="otp-input-container">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="otp-input"
                autoComplete="off"
              />
            ))}
          </div>

          {/* Resend OTP */}
          <div className="otp-resend-section">
            {!canResend ? (
              <p className="resend-timer">
                Resend OTP in <span className="timer-value">{timer}s</span>
              </p>
            ) : (
              <button className="resend-otp-btn" onClick={handleResendOtp}>
                Resend OTP
              </button>
            )}
          </div>

          {/* Verify Button */}
          <button
            className="verify-otp-btn"
            onClick={handleVerify}
            disabled={otp.join("").length !== 6 || isVerifying}
          >
            {isVerifying ? "Verifying..." : "Verify OTP"}
          </button>

          {/* Security Note */}
          <div className="security-note">
            <p>
              <LockIcon className="note-icon" />
              Your OTP is confidential. Never share it with anyone.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ferry_RazorpayOTP;